import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import {Objects} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import CollectionOverride from "components/CollectionOverride";




export default class CustomerDuplicates extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Customers._name);
		super(props, model);
		if( this.props.type === 'pending' ) {
			this.request = 'GET_PENDING';
		} else {
			this.request = 'GET_DUPLICATE';
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if( this.props.type === 'pending' ) {
			this.request = 'GET_PENDING';
		} else {
			this.request = 'GET_DUPLICATE';
		}
	}

	handleToggleModalReview = async (e) => {
		this.setState({
			duplicateId: e.currentTarget.id,
			duplicateBinaryId: e.currentTarget.getAttribute('binary_id'),
			modalReview: true
		});
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [

			{
				Header: "Name",
				accessor: "pkey",
				Cell: props => <Link
					to={"/customers/" + props.original.binary_id + '-' + props.value}>{props.original.name_first} {props.original.name_last}</Link>
			},
			{
				Header: "Phone Number",
				id: "phone",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customer_numberss && obj.customer_numberss.length > 0 && obj.customer_numberss[0].number) ? obj.customer_numberss[0].number : '-'
			},
			{
				Header: "Email",
				id: "email",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customer_emailss && obj.customer_emailss.length > 0 && obj.customer_emailss[0].email) ? obj.customer_emailss[0].email : '-'
			},
			{
				Header: "Address",
				id: "street_1",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customer_addressess && obj.customer_addressess.length > 0 && obj.customer_addressess[0].street_1) ? obj.customer_addressess[0].street_1 + ' ' + obj.customer_addressess[0].city + ', ' + obj.customer_addressess[0].state + ' ' + obj.customer_addressess[0].zip : '-'
			},
			{
				Header: "DOB",
				id: "birth_date",
				width: 100,
				/** @param {Customers_Object} obj */
				accessor: obj => {
					return obj.birth_date ? moment(obj.birth_date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 100,
				Cell: props => {
					return (
						<span>

							<Button
								id={props.original.pkey}
								binary_id={props.original.binary_id}
								onClick={this.handleToggleModalReview}
								color="green-meadow"
								size="sm"
								block={true}
							>
								<i className={"fa fa-balance-scale"}/> Review
							</Button>
						</span>

					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Customers', "")}
							{this.renderHeaderRight("Customers", columns)}

						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>

					<UniversalModalOverride
						id={this.state.duplicateId}
						binary_id={this.state.duplicateBinaryId}
						parent={this.props.parent}
						locations={this.props.locations}
						states={this.props.states}
						history={this.props.history}
						name={"Review"}
						url={'customers'}
						title={"Compare Customers"}
						object={Objects.CustomerCompare}
						toggle={this.state.modalReview}
						reportClose={this.reportClose('modalReview')}
						submitLabel={"Merge Customer"}
						size={"lg"}
						additionalButtons={
							<>
								<Button
									data-id={'different-customers'}
									color="danger"
									onClick={() => {
										this.props.handleTab();
									}}>
									Different Customers
								</Button>
							</>
						}
						// additionalButtons={true}
						// additionalButtonsLabel={"Different Customers"}
						hideGoTo={true}
						afterSave={this.props.reloadPage}
						objectProps={{
							type: this.props.type,
							handleTabChange: this.props.handleTabChange
						}}
					/>

				</CardContent>
			</Card>
		)
	}
}
